import JSEncrypt from "jsencrypt";

const PRIVATE_KEY =
  // eslint-disable-next-line no-multi-str
  "-----BEGIN RSA PRIVATE KEY----- \
  MIIEogIBAAKCAQEA6+8I/W7ZAD/8M2i1vC2aMg69dp7STva/KRnj1qIX0IIV4zXG \
  TSLeHFwb3JBg9EUn/XtRMo8JnIJQ91VoO61Hd1ueZ+V72MxCHAgRbW4983KrVLfZ \
  aVhgXMeLRgfE+M8S0S5fJwaSpkRkqo2yunnmS0/9ij7ZBBEACgQ2o2kH82ZQgOVp \
  FiRUcgHLK9Iur9iZUK9uzPxhCpGmyzmPwBglc049lY1uN4w8wQjMS/jV5Imjl0s+ \
  hw+sASQEPtzcCPC3kvVdd/k1VvCS68gF5wwuWhjlgLlLrX96d3uODCFaAd6ZOj4z \
  Zn8KlExANNx8kbZG4t19ej/r1dYGgErF2fqbPQIDAQABAoIBAEPFKLbrhUeuGXqG \
  5FUGYFlqpH+TRWPLOsPKnQiFDQQmqbTXOHvlvRk2WAZ2LnNb/g2ww3UbYy5ivHEf \
  Rk6GCpY9afX8FCQFICQ/KQpe9UqdsJsoKDo7WYqtAtN93dV+XbBaepiSKcO6t5PK \
  GgG4jC8r7e8s+FdTrsgxx6QOwmrmdpvMOGlbdij0LteQAgMKpnFSesqnKYYClK8N \
  cbkfBBrM0liL4zWHhJDd1wEGAFjktOCxxy/qOQzJtjHtFq3eqFoV3SB94Oyal6QK \
  01Q7tCAsijHqErkXCc0e/GApsI6JsRWIehqP4uWxqfcm6UwA+1XtlvnNJykIssYX \
  fPQMVZ0CgYEA+RXPdxCHr3rlKFb/fK1LedTi1RmUJ2AzMG7ZizmDNYQ/coDkGbT5 \
  G2NjnGK22+HdZZKNLTdTxznpf6ZVL+cUAz/NwYlSKGScLGDrACoGugAzzF6q6sSu \
  d7xINhqrm+yAK8s0BXaiSwNnA7aWKMXbFgzIhwRr2AkOZ8wKWuVlpG8CgYEA8nvC \
  pijA1nWzH+r20eYX4UTR3JQd2asTIN6K2AI6FGUja79FQkSpmDAmu34VnKDCfkSf \
  EEuz/j+36fsXWbykAeWLWrvtrYQr2F7Z0lVlnw2w5oL43rYDmaZsnZFXfRrKnLbV \
  o1mDOGJ5gpkpV4YJFSLuNQKTX8ZO//5nMBCQiRMCgYBiDcLxBRHU85UYTz8eDn4i \
  xLpS11HqOkWMcGa1Fvve6mOrqK+iqwpRTMveuUFwx7ZHEO0AesJBMDwKIylvxRCs \
  wsY1xOARxKFyGukH1IN3XzME5dN0vd5MhlMK8W7S38QI+WJOMEhtLTa1UIBGJrU7 \
  NecOt5/YmKASHlGJPLrJgwKBgGVKLVUbUPJE2D5M+C1V4EPJa6Cofo+eVq80RutU \
  gs5iMRmhHF1CMVXRR1yqnnx+6r+0Cn3UIavjEgA7UtW5ZwkjycJtHiuNOoN3m6Ww \
  5nI6Vdr0euENRxO34Ucwn0szFc/A0B0cFyRGflt/fzWAV+rsXHToToeDXxywOIpr \
  YPThAoGAL47aY0xGW3/89U1jUXr5fagSmdyfXge/dWkBMIg93ntLWHwQZBYixq9y \
  wSW/MJCjzGSoZAwdvprYWIo+de3NgwEETjPJB7jYU90OtYoS46xKusKQXEqkjnsk \
  Qo3uzNqzwjzeAQRHvRF3sirQSgoEnt6dos9N9FGlaYPdc9BBdWU= \
  -----END RSA PRIVATE KEY-----";

export const decryptToken = () => {
  // Get the URL parameters
  const urlParams = new URLSearchParams(window.location.search);
  let encryptedToken = urlParams.get("token");

  if (!encryptedToken) {
    console.log("No token found in URL");
    return null;
  }

  try {
    encryptedToken = encryptedToken
      .replace(/ /g, "+")
      .replace(/%2B/g, "+")
      .replace(/%2F/g, "/")
      .replace(/%3D/g, "=");

    const decrypt = new JSEncrypt();
    decrypt.setPrivateKey(PRIVATE_KEY);
    const decryptedToken = decrypt.decrypt(encryptedToken);

    console.log("Raw decrypted token:", decryptedToken);

    if (!decryptedToken) {
      console.error("Decryption failed - null result");
      return null;
    }

    const tokenData = JSON.parse(decryptedToken);
    return tokenData;
  } catch (error) {
    console.error("Error decrypting token:", error);
    console.error("Error details:", {
      message: error.message,
      stack: error.stack,
    });
    return null;
  }
};
